
import { viewFileByIDService, viewFileService, LoadCustomerGeneralInfo, CustomerGeneralInfoStoreService, LoadCompanyService, CompanyStoreService, LoadApplicationTemplateService, ConfigApplicaitonTemplateService, ApplicationStoreService } from '../../services/CustomerServices';
import * as ActionTypes from '../ActionTypes';
export const LoadCustomerAction = () => {
    return (dispatch) => {
        
        dispatch({type: ActionTypes.LOADING});

        LoadCustomerGeneralInfo().then((res) => {
             
            if(res.hasOwnProperty('success') && res.success === true){
                dispatch({type: ActionTypes.LOAD_CUSTOMER_SUCCESS,res});
               
            }else if(res.hasOwnProperty('success') && res.success === false){
                dispatch({type: ActionTypes.LOAD_CUSTOMER_ERROR,res});
            }
            
        }, error => {
            dispatch({type : ActionTypes.CODE_ERROR, error})
        })
    }
}

export const CustomerGeneralInfoStoreAction = (credentials, setFlagger, flagger, editFlag, setEditFlag, setRenderPage) => {
    return (dispatch) => {
        CustomerGeneralInfoStoreService(credentials).then((res) => {
            if(res.hasOwnProperty('success') && res.success === true){
                setFlagger(true);
                setEditFlag(!editFlag);
                setRenderPage(true);
                dispatch({type: ActionTypes.CUSTOMER_GENERAL_INFO_STORE_SUCCESS, res});
            }else if(res.hasOwnProperty('success') && res.success === false){
                dispatch({type: ActionTypes.CUSTOMER_GENERAL_INFO_STORE_ERROR,res});
            }
            
        }, error => {
            dispatch({type : ActionTypes.CODE_ERROR, error})
        })
    }
}
export const CompanyStoreAction = (credentials, setFlagger, flagger, editFlag, setEditFlag, setCompanyResponse, setRenderPage) => {
    return (dispatch) => {
        CompanyStoreService(credentials).then((res) => {
            if (res.hasOwnProperty('success') && res.success === true) {
                setFlagger(true);
                setEditFlag(!editFlag);
                setRenderPage(true);
                dispatch({ type: ActionTypes.COMPANY_STORE_SUCCESS, res });
            } else if (res.hasOwnProperty('success') && res.success === false) {
                dispatch({ type: ActionTypes.COMPANY_STORE_ERROR, res });
                setCompanyResponse(res);
           
            }

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
    }
}


export const viewFileAction = (item) => {
 
        
   

        return viewFileService(item);
            
  
}
export const viewFileByIDAction = (item) => {




    return viewFileByIDService(item).then((res)=>{
        if (res.hasOwnProperty('success') && res.success === true) {
            return res;
        } else if (res.hasOwnProperty('success') && res.success === false) {
            return res;

        }
    });


}
export const LoadCustomerActionNormal = (id, signal) => {




    return LoadCustomerGeneralInfo(id, signal).then((res) => {
        if (res.hasOwnProperty('success') && res.success === true) {
            return res;
        } else if (res.hasOwnProperty('success') && res.success === false) {
           
            return res;
        }

    });

}
export const LoadCompanyAction = (id, setCompanyResponse) => {




    return LoadCompanyService(id).then((res) => {
        if (res.hasOwnProperty('success') && res.success === true) {
            setCompanyResponse(res);
            return res;
        } else if (res.hasOwnProperty('success') && res.success === false) {
            setCompanyResponse(res);
            return res;
           
        }


    });

}

export const LoadApplicationTemplate = (id, setFlagger, flagger, setResult, formValuesLicensePOE, setFormValuesLicensePOE, defaultValuesLicensePOE, setTemplate, geos)=>{
    
    return (dispatch) => {
        // dispatch({ type: ActionTypes.LOADING });
        LoadApplicationTemplateService(id).then((res) => {
            if (res.hasOwnProperty('success') && res.success === true) {
                setTemplate(id);
                setFlagger(!flagger);
              
                let temp_obj = {};
                let item = [];
                res.data.map((element) => {
                    let array= {};
                   
                    if (element.children != undefined) {

                       
                        element.children.map((secondLevelElement) => {
                           
                            secondLevelElement.fields.map((secondLevelField) => {
                                item.push(secondLevelField);

                            })
                        })


                        element.fields.map((firstLevelField) => {
                            item.push(firstLevelField);

                        })


                        item.map((firstLevelField) => {
                           

                            if (firstLevelField.type == 'file') {

                                temp_obj = firstLevelField.slug == 'municipality' ? { ...temp_obj, [firstLevelField.slug]: [0] } : { ...temp_obj, [firstLevelField.slug]: [] }

                            } 
                            
                            else if (["state_1", "state_2", "state_3"].includes(firstLevelField.slug) || ["municipality_1", "municipality_2", "municipality_3"].includes(firstLevelField.slug) || ["district_1", "district_2", "district_3"].includes(firstLevelField.slug)) {
                                
                                temp_obj = { ...temp_obj, [firstLevelField.slug]: [0] }
                            }
                            else if (["east_1", "east_2", "west_1", "west_2", "south_1", "south_2", "north_1", "north_2"].includes(firstLevelField.slug)) {
                                temp_obj = { ...temp_obj, [firstLevelField.slug]: "90-00-00" }
                            }
                            else {
                                temp_obj = { ...temp_obj, [firstLevelField.slug]: "" }

                            }

                        });



                    } else {
                        return element.fields.map((firstLevelField) => {
                            item.push(firstLevelField);
                            if (firstLevelField.type == 'dropdown'){
                                temp_obj = { ...temp_obj, [firstLevelField.slug]: "0" }
                            }
                            else if (["state_1", "state_2", "state_3"].includes(firstLevelField.slug) || ["municipality_1", "municipality_2", "municipality_3"].includes(firstLevelField.slug) || ["district_1", "district_2", "district_3"].includes(firstLevelField.slug)){
                             
                                temp_obj = { ...temp_obj, [firstLevelField.slug]: [0] }
                            }
                            else if (firstLevelField.type == 'file'  ) {
                             
                                temp_obj = { ...temp_obj, [firstLevelField.slug]: [] }
                              
                            } else if (["east_1", "east_2", "west_1","west_2","south_1","south_2","north_1","north_2"].includes(firstLevelField.slug)) {
                                temp_obj = { ...temp_obj, [firstLevelField.slug]: "90-00-00" }
                            }
                            else{
                                temp_obj = { ...temp_obj, [firstLevelField.slug]: "" }
                              
                            }

                        })
                    }


                })
                temp_obj = {
                    ...temp_obj, 'status': false,
                    status: false,

                    districtFilter: [],
                    municipalityFilter: [],
                    'name_of_the_project_of_electricity':"",
                    'application_letter': []
                   
                 }    
              
              
                
                
                dispatch({ type: ActionTypes.APPLICATION_TEMPLATE_FIELDS_SUCCESS, res });
                setFormValuesLicensePOE(temp_obj);
                setResult(res.data);
                
            } else if (res.hasOwnProperty('success') && res.success === false) {
                dispatch({ type: ActionTypes.APPLICATION_TEMPLATE_FIELDS_ERROR, res });

            }

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
    }
}
export const ConfigApplicaitonTemplate = () => {
    return ConfigApplicaitonTemplateService().then((res) => {
        if (res.hasOwnProperty('success') && res.success === true) {
            return res;
        } else if (res.hasOwnProperty('success') && res.success === false) {

            return res;
        }

    });

    
}

export const ApplicationStoreAction = (template, credentials, setApplicationResponse, setFlagger, history, setDisableButtonSubmit) => {
    return (dispatch) => {
        //dispatch({ type: ActionTypes.LOADING });
        ApplicationStoreService(template,credentials).then((res) => {
            if (res.hasOwnProperty('success') && res.success === true) {


                dispatch({ type: ActionTypes.APPLICATION_STORE_SUCCESS, res });
                history.push("/applications-list/");
                setFlagger(true);
                setDisableButtonSubmit(false);
            } else if (res.hasOwnProperty('success') && res.success === false) {
                dispatch({ type: ActionTypes.APPLICATION_STORE_ERROR, res });
                setApplicationResponse(res)
                setDisableButtonSubmit(false);

            }

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
    }
}
